"use client";
import { jsx } from "react/jsx-runtime";
import { Variants } from "../types.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import GenericImageHandler from "../../../Util/GenericImageHandler.js";
const ImageComponent = ({
  altText,
  categoryTileStyles,
  categoryData,
  variant,
  foreground,
  background,
  imageContainerSx = {},
  imageBackgroundContainerSx = {},
  imageSx
}) => {
  const { imageUrl } = categoryData;
  const { imageStyles = {}, bkgCircleStyles } = categoryTileStyles;
  const isBackgroundOnly = variant === Variants.STACKED && !foreground && background;
  if (isBackgroundOnly) {
    return /* @__PURE__ */ jsx(CostcoBox, { sx: imageStyles });
  }
  return /* @__PURE__ */ jsx(CostcoBox, { sx: imageContainerSx, children: /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        ...bkgCircleStyles,
        ...imageBackgroundContainerSx
      },
      component: "span",
      children: /* @__PURE__ */ jsx(
        GenericImageHandler,
        {
          sx: {
            objectFit: "contain",
            ...imageSx ? imageSx : imageStyles
          },
          alt: altText,
          loading: "lazy",
          src: imageUrl
        }
      )
    }
  ) });
};
export {
  ImageComponent
};
